import {
  LayoutDashboard,
  Users,
  FileText,
  Heart,
  MessageSquare,
  MessagesSquare,
  Video,
  Settings,
  Activity,
  GraduationCap,
  Globe,
  CalendarDays,
  ImageIcon,
  Bell,
  Terminal,
  ClipboardList,
} from 'lucide-react';
import type { TFunction } from 'i18next';

export interface SidebarItem {
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  superAdminOnly?: boolean;
  badgeKey?: 'pendingMembers' | 'unreadContacts';
  permissionModule?: string;
}

export interface SidebarGroup {
  category: string;
  items: SidebarItem[];
}

export function buildSidebarGroups(t: TFunction): SidebarGroup[] {
  return [
    {
      category: t('admin.sidebar.categories.overview'),
      items: [
        { label: t('admin.sidebar.dashboard'), href: '/admin', icon: LayoutDashboard },
      ],
    },
    {
      category: t('admin.sidebar.categories.mission'),
      items: [
        { label: t('admin.sidebar.members'), href: '/admin/members', icon: Users, badgeKey: 'pendingMembers', permissionModule: 'members' },
        { label: t('admin.sidebar.schools'), href: '/admin/schools', icon: GraduationCap, permissionModule: 'schools' },
      ],
    },
    {
      category: t('admin.sidebar.categories.communication'),
      items: [
        { label: t('admin.sidebar.events'), href: '/admin/events', icon: CalendarDays, permissionModule: 'events' },
        { label: t('admin.sidebar.blog'), href: '/admin/blog', icon: FileText, permissionModule: 'blog' },
        { label: t('admin.sidebar.website'), href: '/admin/website', icon: Globe, permissionModule: 'settings' },
        { label: t('admin.sidebar.contacts'), href: '/admin/contacts', icon: MessageSquare, badgeKey: 'unreadContacts', permissionModule: 'contacts' },
        { label: t('admin.sidebar.yimTalk'), href: '/admin/yim-talk', icon: MessagesSquare, permissionModule: 'yimtalk' },
        { label: t('admin.sidebar.yimMeet'), href: '/admin/yim-meet', icon: Video, permissionModule: 'yimmeet' },
        { label: t('admin.sidebar.yimForm'), href: '/admin/yim-form', icon: ClipboardList, permissionModule: 'forms' },
      ],
    },
    {
      category: t('admin.sidebar.categories.media'),
      items: [
        { label: t('admin.sidebar.gallery'), href: '/admin/gallery', icon: ImageIcon, permissionModule: 'gallery' },
      ],
    },
    {
      category: t('admin.sidebar.categories.resources'),
      items: [
        { label: t('admin.sidebar.donations'), href: '/admin/donations', icon: Heart, permissionModule: 'donations' },
      ],
    },
    {
      category: t('admin.sidebar.categories.system'),
      items: [
        { label: t('admin.sidebar.notifications'), href: '/admin/notifications', icon: Bell },
        { label: t('admin.sidebar.auditLogs'), href: '/admin/audit', icon: Activity, permissionModule: 'audit' },
        { label: t('admin.sidebar.serverLogs'), href: '/admin/server-logs', icon: Terminal, superAdminOnly: true },
        { label: t('admin.sidebar.account'), href: '/admin/settings', icon: Settings },
      ],
    },
  ];
}

export function filterSidebarGroups(
  groups: SidebarGroup[],
  isSuperAdmin: boolean,
  canAccess: (module: string) => boolean,
): SidebarGroup[] {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => {
        if (item.superAdminOnly && !isSuperAdmin) return false;
        if (item.permissionModule && !canAccess(item.permissionModule)) return false;
        return true;
      }),
    }))
    .filter((group) => group.items.length > 0);
}
